var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Header"),
      _c("div", { staticClass: "box_content" }, [
        _c(
          "div",
          { staticClass: "box_content_news" },
          [
            _c(
              "el-card",
              { staticClass: "box-card" },
              [
                _vm._l(_vm.notice, function (o) {
                  return _vm.notice.length != 0
                    ? _c("div", { key: o, staticClass: "textitem" }, [
                        _c(
                          "div",
                          {
                            staticClass: "textitem_title",
                            on: {
                              click: function ($event) {
                                return _vm.clicknotice(o)
                              },
                            },
                          },
                          [_vm._v(_vm._s(o.title))]
                        ),
                        _c("div", { staticClass: "textitem_time" }, [
                          _vm._v(_vm._s(o.addtime)),
                        ]),
                      ])
                    : _vm._e()
                }),
                _vm.notice.length == 0
                  ? _c("div", { staticClass: "textitem_title" }, [
                      _vm._v("暂无信息"),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: { title: "通知公告", visible: _vm.noticestatus, width: "60%" },
          on: {
            "update:visible": function ($event) {
              _vm.noticestatus = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 16 } }, [
                _c("div", { staticClass: "box_dialog_heng" }, [
                  _c("b", [_vm._v("标题：")]),
                  _c("span", [_vm._v(_vm._s(_vm.noticecontent.title))]),
                ]),
              ]),
              _c("el-col", { attrs: { span: 8 } }, [
                _c("div", { staticClass: "box_dialog_heng" }, [
                  _c("b", [_vm._v("时间：")]),
                  _c("span", [_vm._v(_vm._s(_vm.noticecontent.addtime))]),
                ]),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "box_dialog_shu" }, [
            _c("b", [_vm._v("内容")]),
            _c("span", {
              staticStyle: { "text-indent": "2em", "line-height": "35px" },
              domProps: { innerHTML: _vm._s(_vm.noticecontent.content) },
            }),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.noticestatus = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }